.content {
  display: flex;
  flex-direction: column;
  gap: 4rem;
  width: 100%;
}

.header {
  display: flex;
  gap: 1.6rem;
  align-items: baseline;
  justify-content: space-between;
}

.steps {
  flex-shrink: 0;
}

.form {
  max-width: 39rem;
}

.help {
  margin-top: auto;
  padding-bottom: 8rem;
}
